import { FACTOR_DATA, FACTOR_RESULT, FACTOR_SETTING, CAL_FACTOR_PRICE } from "Stores/actionTypes";
import { updateObject } from "./utility";

const INIT_STATE = {
  factorData: [],
  factorPagination: { Limit: 5, Page: 1, Total: 0 },
  factorPrice: null,
  factorResult: {
    IdProject: 0,
    ListUnitId: [],
    IsPercentChargePriceProfile: true,
    ChargePriceProfile: 0,
    IsPercentDiscountPriceProfile: true,
    DiscountPriceProfile: 0,
    IsCalcPriceUnit: false,
    CostAngle: 0,
    CostArc: 0,
    Tax: 0,
    RoundPrice: 10,
    PriceTransfer: 0,
    CostJanebi: 0,
    IsPercentCostJanebi: true,
    CostMasrafi: 0,
    IsPercentCostMasrafi: true,
    CostNasb: 0,
    IsPercentCostNasb: true,
    ChargeValueFrameLola: 0,
    ChargeValueFrameRail: 0,
    ChargeValueSashLola: 0,
    ChargeValueSashRail: 0,
    ChargeValueSashDoorLola: 0,
    ChargeValueSashDoorRail: 0,
    ChargeValueMulionLola: 0,
    ChargeValueMulionRail: 0,
    ChargeValuePanelLola: 0,
    ChargeValuePanelRail: 0,
    ChargeValueZehvarLola: 0,
    ChargeValueZehvarRail: 0,
    ChargeValueOtherLola: 0,
    ChargeValueOtherRail: 0,
    ChargeValueProfile: 0,
    ChargeValueGlass: 0,
    ChargeValueNet: 0,
    IsPercentDiscountPriceFitting: true,
    DiscountPriceFitting: 0,
    IsPercentDiscountPriceGlass: true,
    DiscountPriceGlass: 0,
    IsPercentDiscountPriceNet: true,
    DiscountPriceNet: 0,
    IsPercentDiscountPriceOther: true,
    DiscountPriceOther: 0,
    DiscountPrice: 0,
    IsPercentChargePriceFitting: true,
    ChargePriceFitting: 0,
    IsPercentChargePriceGlass: true,
    ChargePriceGlass: 0,
    IsPercentChargePriceNet: true,
    ChargePriceNet: 0,
    IsPercentChargePriceOther: true,
    ChargePriceOther: 0,
    ParamConvert: [],
    ModelOptimalFactor: 0,
    WeastOptimalFactor: 0,
    TypePriceProfile: 1,
    TypePriceFitting: 1,
    TypePriceGlass: 1,
    TypePriceNet: 1,
    TypePriceOther: 1,
    ParamKhadamat: [],
    IdFactorArchive: 0,
  },
  factorSetting: {
    TypeViewFactor: undefined,
    TypeFactor: 1,
    IsFactor: false,
    IsWaterMark: false,
    IsIncOtherProfileToMetrajhUnitBUnit: false,
  }
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FACTOR_DATA:
      return updateObject(state, {
        factorData: action.factorData,
        factorPagination: action.factorPagination,
      });
    case FACTOR_RESULT:
      return updateObject(state, { factorResult: action.factorResult });
    case CAL_FACTOR_PRICE:
      return updateObject(state, { factorPrice: action.price });
    case FACTOR_SETTING:
      return updateObject(state, { factorSetting: action.factorSetting });
    default:
      return state;
  }
};
export default reducer;